<template>
    <div class="main-container">
        <Header />
        <div class="content-container">
            <!-- <div class = "profile-toolbar">
                <el-button 
                class="edit-profile-btn"
                icon="el-icon-save"
                type="danger" @click="handleSaveProfile">保存我的信息</el-button>
            </div> -->
            <div class="profile-container">
                
                <div class = "profile-title">填写北京大学王选所校友分会校友信息</div>
                <div class ="profile-info">
                    <div>分会会员编号：{{anumni.wictMemberId}}</div>
                    <div>最后保存时间：{{$formatDate(anumni.updatedTime)}}</div>
                </div>
                <div class="profile-body">
                  
                  <table class="custom-table">
                    <colgroup>
                      <col style="width: 120px;">
                      <col style="width: 180px;">
                      <col style="width: 120px;">
                      <col style="width: 180px;">
                    </colgroup>
                      <tbody>
                          <!-- 一、个人信息 -->  
                          <tr>
                              <td class="section-header" colspan="5">一、个人信息</td>
                          </tr>
                          <tr>
                              <td class="label-cell">姓 名</td>
                              <td class="input-cell"><el-input v-model="anumni.fullname" placeholder="请输入姓名" maxlength="22" /></td>
                              <td class="label-cell">性 别</td>
                              <td class="input-cell">
                                <el-radio-group v-model="anumni.gender" class="gender-group">
                                  <el-radio :label="0">保密</el-radio>
                                  <el-radio :label="1">男</el-radio>
                                  <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                              </td>
                              <td rowspan="6" class="photo-cell">
                                  <div class="photo-placeholder">
                                    <el-upload ref="avatarUploadRef" 
                                      class="avatar-uploader"
                                      :action="uploadUrl"
                                      :headers="uploadHeaders"
                                      :show-file-list="false"
                                      :on-success="handleAvatarSuccess"
                                      :on-error="handleAvatarError"
                                      :before-upload="beforeAvatarUpload"
                                      :limit="1"                                      
                                      >
                                      <img v-if="anumni.avatar" :src="'/oss/' + anumni.avatar"  class="profile-photo">
                                      <div v-else>
                                        <span>【近期单人照】</span>                                        
                                      </div>
                                      <i  class="el-icon-upload avatar-uploader-icon">点击上传</i>
                                    </el-upload>
                                  </div>
                              </td>
                          </tr>
                          <tr>
                              <td class="label-cell">学 号</td>                                  
                              <td class="input-cell"><el-input v-model="anumni.stuId" placeholder="请输入学号" maxlength="30" /></td>
                              <td class="label-cell">北大校友卡号</td>                                  
                              <td class="input-cell"><el-input v-model="anumni.alumniCardId" placeholder="请输入校友卡号" maxlength="20" /></td>
                          </tr>
                          <tr>
                              <td class="label-cell">学籍院系</td>                                  
                              <td class="input-cell">
                                <el-select v-model="anumni.college" placeholder="请选择学籍院系">
                                  <el-option label="计算机科学技术系" value="计算机科学技术系" />
                                  <el-option label="信息科学技术学院" value="信息科学技术学院" />
                                  <el-option label="软件与微电子学院" value="软件与微电子学院" />
                                  <el-option label="前沿交叉学科研究院" value="前沿交叉学科研究院" />
                                  <el-option label="智能学院" value="智能学院" />
                                  <el-option label="计算机学院" value="计算机学院" />
                                </el-select>
                              </td>
                              <td class="label-cell">年 级</td>                              
                              <td class="input-cell"><el-input v-model="anumni.grade" placeholder="请输入年级" maxlength="18" /></td>
                          </tr>
                          <tr>
                              <td class="label-cell">身份证号</td>                              
                              <td class="input-cell"><el-input v-model="anumni.idCard" placeholder="请输入身份证号" maxlength="18" /></td>
                              <td class="label-cell">出生日期</td>                                  
                              <td class="input-cell"><el-date-picker v-model="anumni.birthday" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择出生日期" style="width: 100%;" /></td>
 
                          </tr>
                          <tr>
                              <td class="label-cell">民 族</td>
                              <td class="input-cell"><el-input v-model="anumni.nation" placeholder="请输入民族" maxlength="30" /></td>
                              <td class="label-cell">政治面貌</td> 
                              <td class="input-cell">
                                <el-select v-model="anumni.politicStatus"         
                                filterable                        
                                clearable
                                placeholder="选择/输入政治面貌">
                                  <el-option label="中共党员" value="中共党员" />
                                  <el-option label="中共预备党员" value="中共预备党员" />
                                  <el-option label="共青团员" value="共青团员" />
                                  <el-option label="群众" value="群众" />
                                  <el-option label="九三学社社员" value="九三学社社员" />
                                  <el-option label="民革党员" value="民革党员" />
                                  <el-option label="民盟盟员" value="民盟盟员" />
                                  <el-option label="民建会员" value="民建会员" />
                                  <el-option label="民进会员" value="民进会员" />
                                  <el-option label="农工党党员" value="农工党党员" />
                                  <el-option label="致公党党员" value="致公党党员" />
                                  <el-option label="台盟盟员" value="台盟盟员" />
                                </el-select>
                              </td>                              
                          </tr>
                          <tr>
                            
                              <td class="label-cell">籍 贯</td>
                              <td class="input-cell"><el-input v-model="anumni.originAddr" placeholder="请输入籍贯" maxlength="60" /></td>
                              <td class="label-cell"></td>
                              <td class="input-cell"></td>
                            
                          </tr>
                          <!-- 二、教育信息 --> 
                          <tr>
                              <td class="section-header" colspan="5">二、教育信息</td>
                          </tr>
                          <tr>
                              <td class="label-cell">博士学习</td>
                              <td class="input-cell" colspan="4">                                  
                                  <div class = "cell-box"><span>博士学习起止时间：</span><el-date-picker v-model="doctorEducation.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" /> - <el-date-picker v-model="doctorEducation.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间" /></div>
                                  <div class = "cell-box"><div class="cell-box-label">导师姓名：</div><el-input v-model="doctorEducation.tutorName" placeholder="请输入导师姓名" maxlength="60" /></div>                                      
                                  <div class = "cell-box"><div class="cell-box-label">博士学习研究方向：</div><el-input v-model="doctorEducation.research" placeholder="请输入研究方向" /></div>                                                                                            
                              </td>
                          </tr>                            
                          <tr>
                              <td class="label-cell">硕士学习</td>
                              <td class="input-cell" colspan="4">                                  
                                  <div class = "cell-box"><span>硕士学习起止时间：</span><el-date-picker v-model="masterEducation.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" /> - <el-date-picker v-model="masterEducation.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间" /></div>               
                                  <div class = "cell-box"><div class="cell-box-label">导师姓名：</div><el-input v-model="masterEducation.tutorName" placeholder="请输入导师姓名" maxlength="60" /></div>                                      
                                  <div class = "cell-box"><div class="cell-box-label">硕士学习研究方向：</div><el-input v-model="masterEducation.research" placeholder="请输入研究方向" /></div>
                              </td>
                          </tr> 
                          <tr>
                              <td class="label-cell">博士后工作</td>
                              <td class="input-cell" colspan="4">                                  
                                  <div class = "cell-box"><span>博士后在站起止时间：</span><el-date-picker v-model="postDoctorWork.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" /> - <el-date-picker v-model="postDoctorWork.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间" /></div>               
                                  <div class = "cell-box"><div class="cell-box-label">合作导师：</div><el-input v-model="postDoctorWork.tutorName" placeholder="请输入合作导师姓名" maxlength="60" /></div>                                      
                                  <div class = "cell-box"><div class="cell-box-label">博士后主要研究方向：</div><el-input v-model="postDoctorWork.research" placeholder="请输入研究方向" /></div>

                              </td>
                          </tr>
                          <tr>
                              <td class="label-cell">教职工工作</td>
                              <td class="input-cell" colspan="4">
                                <div class = "cell-box"><span>来所工作起止时间：</span><el-date-picker v-model="teacherWork.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" /> - <el-date-picker v-model="teacherWork.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间" /></div>                                        
                                <div class = "cell-box"><div class="cell-box-label">主管领导：</div><el-input v-model="teacherWork.leader" placeholder="请输入主管领导姓名" maxlength="60" /></div>                                
                                <div class = "cell-box"><div class="cell-box-label">在所主要工作任务/研究方向：</div><el-input v-model="teacherWork.workContent" placeholder="请输入主要工作任务/研究方向" /></div>
                              </td>
                          </tr>
                          <tr>
                              <td class="label-cell">在所期间任职或获奖</td>                              
                              <td class="input-cell" colspan="4"><el-input v-model="anumni.honorInfo" placeholder="请输入在所期间任职或获奖信息" type="textarea" rows="3" /></td>
                          </tr>
                          <!-- 三、工作和发展情况 --> 
                          <tr>
                              <td class="section-header" colspan="5">三、工作和发展情况</td>
                          </tr>
                          <tr>
                              <td class="label-cell">目前工作</td>
                              <td class="input-cell" colspan="4">                                
                                <div class = "cell-box"><div class="cell-box-label">1.目前从事的行业或工作领域：</div><el-input v-model="currentCareer.industry" placeholder="请输入目前从事的行业或工作领域" maxlength="60" /></div>
                                <div class = "cell-box"><div class="cell-box-label">2.所在地/城市：</div><el-input v-model="currentCareer.city" placeholder="请输入所在地/城市" maxlength="120" /></div>
                                <div class = "cell-box"><div class="cell-box-label">3.目前单位名称：</div><el-input v-model="currentCareer.company" placeholder="请输入目前单位名称" maxlength="120" /></div>
                                <div class = "cell-box"><div class="cell-box-label">4.职务/职称：</div><el-input v-model="currentCareer.jobTitle" placeholder="请输入职务/职称" maxlength="60" /></div>
                              </td>
                          </tr>
                          <!-- <tr>
                              <td class="label-cell">主要履历</td>
                              <td class="input-cell" colspan="4">
                                  <template v-if="careerList && careerList.length > 0">
                                      <div v-for="item in careerList" :key="item.id">
                                          {{item.industry}} {{item.city}} {{item.company}} {{item.jobTitle}}
                                      </div>
                                  </template>
                                  <template v-else>
                                      <div>/</div>                                        
                                  </template>
                              </td>
                          </tr> -->
                          <!-- 四、校友联络 --> 
                          <tr>
                              <td class="section-header" colspan="5">四、校友联络</td>
                          </tr>
                          <tr>
                              <td class="label-cell">手机号</td>
                              <td class="input-cell" colspan="1"><el-input v-model="anumni.mobile" placeholder="请输入手机号" maxlength="60" /></td>
                              <td class="label-cell">常用邮箱</td>
                              <td class="input-cell" colspan="2"><el-input v-model="anumni.email" placeholder="请输入常用邮箱" maxlength="60" /></td>
                          </tr>
                          <tr>
                              <td class="label-cell">微信联络</td>
                              <td class="input-cell" colspan="4">
                                  <div class = "cell-box"><div class="cell-box-label">本人微信号：</div><el-input v-model="anumni.wxNo" placeholder="请输入本人微信号" maxlength="60" /></div>
                                  <div class = "cell-box"><div class="cell-box-label">已加入WICT校友大群：</div><el-input v-model="anumni.wxGroup" placeholder="请输入已加入WICT校友大群" maxlength="60" /></div>
                              </td>
                          </tr>
                          <tr>
                              <td class="label-cell">校友联络</td>
                              <td class="input-cell" colspan="4">
                                  <div class = "cell-box"><div class="cell-box-label">年级联络人姓名：</div><el-input v-model="anumni.gradeContact" placeholder="请输入年级联络人姓名" maxlength="24" /></div>
                                  <div class = "cell-box"><div class="cell-box-label">联系较多的校友有：</div><el-input v-model="anumni.linkAlumni" placeholder="请输入联系较多的校友" maxlength="60" /></div>                                  
                              </td>
                          </tr>
                          <tr>
                              <td class="label-cell">业余爱好</td>
                              <td class="input-cell" colspan="4"><el-input v-model="anumni.hobby" placeholder="请输入业余爱好" type="textarea" rows="2" /></td>
                          </tr>
                          <!-- 五、对王选所校友分会的期望和建议 --> 
                          <tr>
                              <td class="section-header" colspan="5">五、对王选所校友分会的期望和建议</td>
                          </tr>
                          <tr>                
                              <td class="label-cell">期望与建议</td>                
                              <td class="input-cell" colspan="4">
                                  <el-input v-model="anumni.suggest" placeholder="请输入期望与建议" type="textarea" rows="3" />
                              </td>
                          </tr>
                      </tbody>
                  </table>
                  
                </div>                
                <div class="profile-footer">
                    <div>“科教兴国，人才强国。”——王选  二〇〇六年一月三日</div>
                </div>
                <div class="bottom-toolbar">
                  <el-button                                 
                    type="plain" @click="handleBackProfileDetail">返回</el-button>

                    <el-button 
                    class="edit-profile-btn"
                    icon="el-icon-save"
                    type="danger" @click="handleSaveProfile">保存我的信息</el-button>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import { getMyProfile, saveMyProfile } from "@/api/alumniApi";
import { getGenderName } from "@/utils/constUtil";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      anumni: {
        alumniId: undefined,
        wictMemberId: "",
        fullname: "",
        gender: 0,
        birthday: "",
        alumniCardId: "",
        idCard: "",
        politicStatus: "",
        nation: "",
        originAddr: "",
        mobile: "",
        email: "",
        wxNo: "",
        wxGroup: "",
        gradeContact: "",
        linkAlumni: "",
        hobby: "",
        suggest: "",
        honorInfo: "",
        avatar: "",
        updatedTime: "",
        educationList: [],
        workList: [],
        careerList: [],
        stuId: "",
      },
      // 博士学习经历
      doctorEducation: {
        eduType: 3,
      },
      // 硕士学习经历
      masterEducation: {
        eduType: 2,
      },
      // 博士后工作经历
      postDoctorWork: {
        eduType: 4,
      },
      // 教职工工作：先默认一条，后面再完善支持多条
      teacherWork: {},
      // 当前工作：先默认一条，后面再完善支持多条
      currentCareer: {},
      // 主要履历
      careerList: [],
      // 上传照片
      uploadUrl: process.env.VUE_APP_API_URL + "/system/oss/upload",
      // 上传请求头
      uploadHeaders: {
        "Authorization": "",
      },
    }
  },
  created() {
    // 上传请求头添加 Authorization
    let token = "Bearer " + encodeURIComponent(localStorage.getItem("access-token"));    
    this.uploadHeaders.Authorization = token;

    this.$nextTick(() => {
      this.loadData();
    });
  },
  methods: {
    getGenderName,
    loadData(){
        getMyProfile().then(res => {
            if (res.code === 200) {
                this.anumni = res.data;
                this.initData();
            }else{
                this.$message.error(res.msg);
                this.anumni = {};
            }
        }).catch(err => {
            this.$message.error(err.message);
            this.anumni = {};
        });
    },
    // 初始化数据
    initData(){
        if (!this.anumni) {
            return;
        }
        // 教育信息
        if(this.anumni.educationList && this.anumni.educationList.length > 0){
            for(let item of this.anumni.educationList){
                if(item.eduType === 2){
                    this.masterEducation = item || {};
                }else if(item.eduType === 3){
                    this.doctorEducation = item || {};
                }else if(item.eduType === 4){
                    this.postDoctorWork = item || {};
                }
            }
        }
        // 教职工工作        
        if(this.anumni.workList && this.anumni.workList.length > 0){
            this.teacherWork = this.anumni.workList[0] || {};
        }
        // 当前工作
        if(this.anumni.careerList && this.anumni.careerList.length > 0){
            this.currentCareer = this.anumni.careerList[0] || {};            
        }
    },

    // 保存个人信息
    handleSaveProfile(){
        // 校验数据：姓名不能为空
        if(!this.anumni.fullname){
            this.$message.error("请输入姓名");
            return;
        }
        // 校验数据：学号不能为空
        if(!this.anumni.stuId){
            this.$message.error("请输入学号");
            return;
        }
        // 补充教育信息
        this.anumni.educationList = [];
        if(this.masterEducation){
            this.anumni.educationList.push(this.masterEducation);
        }
        if(this.doctorEducation){
            this.anumni.educationList.push(this.doctorEducation);
        }
        if(this.postDoctorWork){
            this.anumni.educationList.push(this.postDoctorWork);
        }
        // 补充教职工工作
        this.anumni.workList = [];
        if(this.teacherWork){
            this.anumni.workList.push(this.teacherWork);
        }
        // 补充当前工作
        this.anumni.careerList = [];
        if(this.currentCareer){
          // 默认为当前工作
          this.currentCareer.isCurrent = 1;
          this.anumni.careerList.push(this.currentCareer);
        }


        // 询问用户确认保存
        this.$confirm("确认保存吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            // 调用保存接口
            saveMyProfile(this.anumni).then(res => {
                if (res.code === 200) {
                    this.$message.success("保存成功");
                    // 跳转到详情页
                    this.$router.push("/");
                }else{
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.$message.error(err.message);
            });
        }).catch(() => {
            // 用户点击取消
        });
        
    },

    // 返回详情页
    handleBackProfileDetail(){
      this.$router.push("/");
    },
    // 上传照片成功
    handleAvatarSuccess(res, file){
      console.log(res, file);
        if (res.code === 200) {
            this.anumni.avatar = res.data.fileName;
        }else{
            this.$message.error(res.msg);
        }
    },
    // 上传照片前校验
    beforeAvatarUpload(file){
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('上传照片只能是 JPG/PNG 格式!');
        return false;
      }
      return true;
    },
    // 上传照片失败
    handleAvatarError(file, message){
        this.$message.error(message);
    },

  },

  
}
</script>
<style scoped>
.profile-container {
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 800px;
}
.profile-toolbar {
    width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  box-sizing: border-box;
}
.edit-profile-btn {
  background: rgba(148, 8, 11, 1);  
  outline: none;
  border: none;
}
.edit-profile-btn:hover {
  opacity: 0.8;
  background: rgba(148, 8, 11, 1);  
}
.profile-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
.profile-info {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}
.profile-body {
  margin-bottom: 20px;
}
.profile-footer {
  text-align: center;
  margin-top: 20px;
  color: #666;
  font-size: 12px;
}
.header-section {
  position: relative;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
}
/* 表格通用样式 - 核心部分 */

.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  table-layout: fixed; /* 固定布局防止内容撑开 */
}

.custom-table td {
  border: 1px solid #000; /* 黑色实线边框 */
  padding: 10px;
  font-size: 14px;
  color: #333;
}

/* 左侧标签列 */
.label-cell {
  background-color: #f0f2f5; /* 浅灰背景 */
  width: 100px;
  text-align: center;
  font-weight: bold;
  white-space: wrap;
}

/* 区域标题栏样式 */
.section-header {
  background-color: #f0f2f5; 
  color: #303133;            
  font-weight: bold;         
  text-align: center;        
  padding: 8px 0;             
  letter-spacing: 2px;  
}

/* 输入单元格 */
.input-cell {
  padding: 5px !important;  
}

.cell-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.cell-box-label{
  flex: 0 0 auto;
  white-space: nowrap;
}
/* 照片占位符 */
.photo-cell {
  width: 120px;
  text-align: center;
  vertical-align: middle;
  color: #1890ff;
}
.photo-cell img {
  width: 100%;
  height: 100%;
}
.photo-placeholder {
  display: inline-block;
}

/* 垂直居中辅助类 */
.vertical-middle {
  vertical-align: middle;
}

/* 子行样式（用于一行内有多个输入项的情况） */
.sub-row {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.sub-row-text {
  margin-bottom: 5px;
  color: #666;
  font-style: italic;
}

.bottom-toolbar {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
}
.gender-group{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.gender-group .el-radio{
  margin-right: 0;
}

</style>
